angular.module('impactx.search').directive('ixCategoryFilters', function () {
    return {
        restrict: 'E',
        controller: 'SearchCtrl',
        controllerAs: 'ctrl',
        templateUrl: 'modules/search/templates/categoryfilters.html'
    }
});